import * as moment from 'moment';
import 'moment/locale/pt-br';
import Moment from 'react-moment';

export default () => {
  moment.locale('pt-br');
  Moment.globalMoment = moment;
  Moment.globalParse = 'x';
  Moment.globalLocale = 'pt-br';
};



// WEBPACK FOOTER //
// ./src/App/initializers/moment.js